import { Stack } from '@mui/material';
import CircleColor from './circle-color';
import LicensePlate from './license-plate';

const LicensePlateColor = ({ licensePlate, color, variant = 'subtitle2', align = 'center', licenceSx = {}, colorSx = {} }) => {
  return (
    <Stack direction="row" columnGap={1} alignItems="center" justifyContent={align}>
      <LicensePlate variant={variant} sx={licenceSx}>
        {licensePlate}
      </LicensePlate>
      <CircleColor color={color} sx={colorSx} />
    </Stack>
  );
};

export default LicensePlateColor;
